import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import BaseConfirmationDialog from './BaseConfirmationDialog';
import {go} from '../../utils/navigationUtility';
import {withRouter} from 'react-router-dom';
import {getUserStatus, isAdmin, isSchoolUser, isStudent, isTeacher} from '../../utils/userUtility';
import {computed} from 'mobx';
import {UserStatus} from '../../constants/enums';

@injectIntl
@withRouter
@inject('userStore', 'manageStore')
@observer
class TrialEndedDialog extends Component {
    goToPricing = () => {
        go('/pricing');
    }

    @computed get showDialog() {
        if (this.props.userStore.isAuthenticated && !this.props.location.pathname.match(/pricing|payment/) && !isSchoolUser() && !isAdmin()) {
            if (isTeacher()) {
                return getUserStatus() === UserStatus.TrialEnded;
            }
            if (!this.props.manageStore.isProcessing) {
                return !this.props.manageStore.hasActivePayment;
            }
        }
        return false;
    }


    render() {
        return <BaseConfirmationDialog
            withClose={false}
            onSubmit={this.goToPricing}
            onDismiss={() => {}}
            open={this.showDialog}
            buttonText={isTeacher() ? 'subscribeNow' : null}
            withConfirm={!isStudent()}
            text={{
                question: isTeacher() ? 'payment.expired.teacher.title' : 'payment.expired.student.title',
                message: isTeacher() ? 'payment.expired.teacher.message' : 'payment.expired.student.message'
            }}
            isCancel={false}
        />;
    }
}

export default TrialEndedDialog;
